import { AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DescuentosService } from 'src/app/services/transacciones/descuentos.service';
import { LanguageApp } from '../../laboratorio/laboratorios/laboratorios.component';

@Component({
  selector: 'app-descuentos',
  templateUrl: './descuentos.component.html',
  styleUrls: ['./descuentos.component.scss'],
  standalone: false
})
export class DescuentosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public descuentos: any[] = [];
  public spinnerBoolean = false;
  public fechaInicio: string = '';
  public fechaFin: string = '';

  get token(): string { return localStorage.getItem('token') || ''; }

  constructor(
    private descuentosService: DescuentosService,
    public router: Router,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    const hoy = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Guayaquil' });
    this.fechaInicio = hoy;
    this.fechaFin = hoy;
    this.buildDtOptions();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.isDtInitialized = true;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  aplicarFiltros(): void {
    if (this.isDtInitialized) {
      this.dtElement?.dtInstance?.then(dt => dt.ajax.reload());
    }
  }

  private buildDtOptions(): void {
    this.dtOptions = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      responsive: true,
      orderClasses: false,
      searchDelay: 1500,
      ajax: (dtParams: any, callback: any) => {
        this.ngZone.run(() => { this.descuentos = []; this.spinnerBoolean = true; });

        this.descuentosService.listarDescuentos(this.token, {
          fechaInicio: this.fechaInicio,
          fechaFin:    this.fechaFin,
          start:       dtParams.start,
          length:      dtParams.length,
          search:      dtParams.search?.value || '',
        }).subscribe({
          next: (resp: any) => {
            this.ngZone.run(() => {
              this.descuentos = Array.isArray(resp?.data) ? resp.data : [];
              this.spinnerBoolean = false;
              callback({
                recordsTotal:    resp?.recordsTotal    || 0,
                recordsFiltered: resp?.recordsFiltered || 0,
                data: [],
              });
            });
          },
          error: () => {
            this.ngZone.run(() => {
              this.descuentos = [];
              this.spinnerBoolean = false;
              callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
            });
          }
        });
      },
    };
  }

  crearDescuento(): void {
    this.router.navigate(['/sistema/crear-descuento']);
  }

  eliminarDescuento(codTrac: number, secuencial: string): void {
    Swal.fire({
      title: '¿Eliminar descuento?',
      html: `Se eliminará el descuento <strong>${secuencial}</strong> de forma permanente.<br>Esta acción no se puede deshacer.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (!result.isConfirmed) return;
      this.descuentosService.eliminarDescuento(codTrac).subscribe({
        next: () => {
          Swal.fire({ icon: 'success', title: 'Eliminado', text: 'El descuento fue eliminado.', timer: 1500, showConfirmButton: false });
          this.dtElement?.dtInstance?.then(dt => dt.ajax.reload(undefined, false));
        },
        error: () => {
          Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar el descuento.' });
        }
      });
    });
  }

  formatFecha(fecha: string): string {
    if (!fecha) return '';
    try {
      const d   = new Date(fecha);
      const TZ  = 'America/Guayaquil';
      const dia = d.toLocaleDateString('en-CA', { timeZone: TZ }).split('-').reverse().join('/');
      const hora = d.toLocaleTimeString('en-GB', { timeZone: TZ, hour12: false }).slice(0, 5);
      return `${dia} ${hora}`;
    } catch { return fecha; }
  }
}
